<template>
    <div>
      <div class="common-seach-wrap">
        <el-form
          size="small"
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
        >
          <el-form-item label="创建时间"
            ><el-input
              size="small"
              v-model="searchForm.name"
              placeholder="自定义事件"
            ></el-input
          ></el-form-item>
          <el-form-item label="订单收索"
            ><el-input
              size="small"
              v-model="searchForm.mobile"
              placeholder="请输入交易单号交易人"
            ></el-input
          ></el-form-item>
          <el-form-item
            ><el-button size="small" type="primary" icon="el-icon-search"
              >查询</el-button
            ></el-form-item
          >
        </el-form>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column fixed prop="id" label="ID" width="150">
        </el-table-column>
        <el-table-column label="头像" width="150">
          <template slot-scope="scope">
            <img v-img-url="scope.row.imgurl" width="50px" height="50px" />
          </template>
        </el-table-column>
        <el-table-column label="用户信息" width="150">
          <template slot-scope="scope">
            昵称： {{ scope.row.nickname }}<br />
            姓名： {{ scope.row.name }}<br />
            手机号： {{ scope.row.mobile }}<br />
          </template>
        </el-table-column>
        <el-table-column prop="pay" label="推广用户数据" width="">
        </el-table-column>
        <el-table-column prop="order_num" label="推广订单"> </el-table-column>
        <el-table-column prop="money" label="推广订单金额" width="150">
        </el-table-column>
        <el-table-column prop="level" label="分销等级"> </el-table-column>
        <el-table-column prop="use_money" label="可用佣金"> </el-table-column>
        <el-table-column prop="total_money" label="累计佣金"> </el-table-column>
        <el-table-column prop="createTime" label="加入时间"> </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.statu"
              active-color="#13ce66"
              inactive-color="#ccc"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="danger" size="small">删除</el-button>
            <el-button type="primary" size="small" @click="editClick(scope.row)"
              >等级</el-button
            >
          </template>
        </el-table-column>
      </el-table>
  
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
      <!-- <Grade
        v-if="open_edit"
        :open_edit="open_edit"
        :form="userModel"
        :gradeList="gradeList"
        @closeDialog="closeDialogFunc($event, 'edit')"
      ></Grade> -->
    </div>
  </template>
  
  <script>
//   import Grade from "./dialog/Grade.vue";
  
  export default {
    // components: {
    //   Grade
    // },
    methods: {
      editClick(item) {
        this.userModel = item;
        this.open_edit = true;
      },
      handleClick(row) {
        console.log(row);
      },
  
      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == "add") {
          this.open_add = e.openDialog;
          if (e.type == "success") {
            this.getTableList();
          }
        }
        if (f == "edit") {
          this.open_edit = e.openDialog;
          if (e.type == "success") {
            this.getTableList();
          }
        }
        if (f == "tag") {
          this.open_tag = e.openDialog;
          if (e.type == "success") {
            this.getTableList();
          }
        }
      },
      handleCurrentChange() {}
    },
  
    data() {
      return {
        open_edit: false,
        gradeList: [{ name: "普通", id: 1 }],
        options: [
          {
            value: "选项1",
            label: "升序"
          },
          {
            value: "选项2",
            label: "降序"
          }
        ],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 4,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        searchForm: {
          name: "",
          mobile: "",
          style: ""
        },
        tableData: [
          {
            id: "1",
            date: "2016-05-02",
            nickname: "w",
            mobile: "1566666666",
            name: "王小虎",
            province: "上海",
            city: "普陀区",
            order_num: "5",
            address: "上海市普陀区金沙江路 1518 弄",
            orderNo: 200333,
            matinfo: "毛巾",
            pay: "100",
            money: "99.89",
            level: "1",
            use_money: "22.90",
            total_money: "99.89",
            createTime: "2023年8月29日 12:33",
            order_status_text: "已完成",
            pay_type: "微信",
            type: "申请入驻",
            remark: "",
            statu: false,
            imgurl: "https://ruanchengshangmen.rchz.top/image/jishi/clock.png"
          }
        ]
      };
    }
  };
  </script>
  


// WEBPACK FOOTER //
// src/views/supplier/water/index.vue